<button
  class="rating-btn p-mr-3"
  *ngFor="let ratingId of ratingArray; index as i"
  [id]="'star_' + i"
  (click)="calculateRating(i + 1)"
>
  <img [src]="iconStatus(i)" />
</button>
